import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { useNotification } from "../hooks";

const deleteTestCaseFromTestSuite = async ({ id, selectedcases, index }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteTCfromTSuite&companyid=${user.companyid}&idtest_suite=${id}&index=${index}`,
      selectedcases,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });

  return response;
};

const useDeleteTestCaseFromTestSuiteQuery = (options = {}) => {
  const queryClient = useQueryClient();
  const notify = useNotification();

  return useMutation({
    mutationFn: deleteTestCaseFromTestSuite,
    onSuccess: (response, variables) => {
      // queryClient.invalidateQueries(["testCaseResults", "searchTCSearch", "moveToTestSuite"]);
      queryClient.invalidateQueries(["moveToTestSuite"]);
      queryClient.invalidateQueries({
        queryKey: ["testCasesInSuite"],
        exact: false,
      });
      if (variables?.isSearchMode) {
        queryClient.invalidateQueries({
          queryKey: ["fetchSearchInSuite"],
          exact: false,
        });
      }

      notify("Test case deleted", "success");
      if (options?.onSuccess) {
        options.onSuccess(response, variables);
      }
    },
    onError: (error) => {
      console.log("Error deleting", error.message);
    },
  });
};

export default useDeleteTestCaseFromTestSuiteQuery;
